<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Ek Ürün İşlemleri
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div class="padding-bottom-10">
                        <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Ek Ürün</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-circle-edit-outline  mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Ek Ürün</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                        <div class="aciklamaListesi">
                            <ul>
                                <li class="renk-duzenle"><i class="el-icon-edit"></i> Düzenle</li>
                                <li class="renk-silinen"><i class="mdi mdi-delete"></i> Sil</li>
                                <li class="renk-detay"><i class="mdi mdi-play"></i> Aktif Yap</li>
                            </ul>
                        </div>
                    </div>
                    <el-table
                            :data="ekUrunListesi"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Ek Ürün Adı"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="ektedavi"
                                label="Ek Tedavi"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="200"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiaktif")'
                                            :open-delay="200"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0'"
                                            @click="durumChange(scope.row,scope.$index,ekUrunListesi,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="200"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next, jumper, total"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="pageChange"
                            :page-sizes="[10, 20, 50, 100]"
                            :current-page.sync="page"
                            :next-click.sync="page"
                            :prev-click.sync="page"
                            @next-click="pageChange"
                            @prev-click="pageChange">
                    </el-pagination>
                </div>

            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="urunForm" :rules="rulesAracUrun" ref="urunForm" @submit.native.prevent="enter"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Ek Ürün Adı'
                                                  prop="baslik">:
                                        <el-input
                                                  v-model="urunForm.baslik"
                                                  placeholder='Ek Ürün Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Ek Tedavi'
                                                  prop="ekUrunKategori">:
                                        <el-select
                                                filterable
                                                v-model="urunForm.ekUrunKategori"
                                                placeholder='Ek Tedavi Seçiniz'
                                                style="width: 100%">
                                            <el-option v-for="item in ekUrunKategoriListesi"
                                                       :key="item.ektedaviId"
                                                       :label="item.baslik"
                                                       :value="item.ektedaviId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button class="estas-buton" v-if="btnVisible" size="small" v-on:click="urunTanimla('urunForm')"
                                           type="primary">
                                    Tanımla
                                </el-button>
                                <el-button class="estas-buton" v-else size="small" v-on:click="guncelleme('urunForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button class="estas-buton-border" v-if="!btnVisible" size="small" v-on:click="vazgec('urunForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" ek ürününü silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="durumChange(selection,selectionIndex,ekUrunListesi,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import cerrahiService from '../../../../WSProvider/CerrahiService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userData3H = "";
    export default {
        name: "UrunIslemleri",
        mounted() {
            this.markaCount();
            this.getEkUrunListesi();
            this.getEkUrunKategori();
        },
        data() {
            return {
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                ekUrunListesi: [],
                ekUrunKategoriListesi: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                urunForm: {
                    baslik: '',
                    ekUrunKategori: '',
                },
                rulesAracUrun: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Urun Giriniz",
                        trigger: 'blur'
                    }],
                    ekUrunKategori: [{
                        required: true,
                        message: "Lütfen Kategori Seçiniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getEkUrunListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.markaCount();
                this.getEkUrunListesi();
            },
            markaCount() {
                cerrahiService.ekUrunListesi(this.selectIcon,"","").then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data.length);
                    }
                });
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getEkUrunListesi();
            },
            getEkUrunListesi() {
                cerrahiService.ekUrunListesi(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.ekUrunListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getEkUrunKategori(){
                cerrahiService.ekTedaviListesi(1, "", "").then((response) => {
                    if (response.status === 200) {
                        this.ekUrunKategoriListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                this.urunForm.baslik = scope.baslik;
                this.urunForm.ekUrunKategori = scope.ektedaviId;
                this.updateKodu = scope.ekurunId;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            enter(){
                if(this.btnVisible){
                    this.urunTanimla('urunForm') ;
                }else this.guncelleme('urunForm')
            },
            urunTanimla(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        cerrahiService.ekUrunTanimlama(this.urunForm.baslik,this.urunForm.ekUrunKategori).then((response) => {
                            if (response.status === 200) {
                                this.ekUrunListesi.push(response.data);
                                notification.Status('success', this, 'Ek Ürün başarıyla eklendi.');
                                this.markaCount();
                                this.getEkUrunListesi();
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ek ürün zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        cerrahiService.ekUrunGuncelleme(this.updateKodu, this.urunForm.baslik, this.urunForm.ekUrunKategori).then((response) => {
                            if (response.status === 200) {
                                this.ekUrunListesi.splice(this.selectionIndex, 1);
                                this.ekUrunListesi.splice(this.selectionIndex, 0, {
                                    baslik: response.data.baslik,
                                    ekurunId: response.data.ekurunId
                                });
                                this.markaCount();
                                this.getEkUrunListesi();
                                notification.Status('success', this, 'Ek Ürün başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ek ürün zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            durumChange(selection, index, list,durum) {
                cerrahiService.ekUrunDurumGuncelleme(selection.ekurunId,durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Ek Ürün durumu başarıyla değiştirildi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

</style>